import { message } from "antd";
import { postArchiveConversation } from "V2.0/services/conversationService";
import { showErrorToast } from "V2.0/utils";

export async function archiveConversation(conversation, syncConversation) {
  message.loading("Archiving Conversation");

  const workspaceId = conversation.workspace;
  const conversationId = conversation._id;

  try {
    const response = await postArchiveConversation({
      workspaceId,
      conversationId,
    });

    if (response.status === 200) {
      message.destroy();
      message.success("Conversation Archived");

      syncConversation({
        ...conversation,
        status: "ARCHIVED",
      });
    }
  } catch (e) {
    showErrorToast(e, "Failed to Archive Conversation");
  }
}
